import * as React from "react";
import { observer } from "mobx-react-lite";
import AppModal from "../../common/components/AppModal";
import { UserModel } from "../types/UserModel";

type Props = {
    open: boolean;
    user: UserModel | null;
    onCancel: () => void;
    onConfirm: () => void;
};

export const DeleteUserDialog: React.FC<Props> = observer(
    ({ open, user, onCancel, onConfirm }) => (
        <AppModal
            open={open}
            closable={false}
            maskClosable={false}
            title="Please confirm"
            onCancel={onCancel}
            cancelButtonTitle="Cancel"
            onCancelClick={onCancel}
            submitButtonTitle="Remove user"
            onSubmitClick={onConfirm}
            centered
            className="alpha-portal-dialog two-columns confirm"
        >
            Are you sure that you want to delete user{" "}
            {user
                ? `${user.firstName} ${user.lastName} (${user.userName})`
                : ""}
            ? This action cannot be undone.
        </AppModal>
    ),
);

export default DeleteUserDialog;
